import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPieChartEmpty = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={170} height={170} fill='none' {...props}>
    <path
      fill='#F3F5F9'
      d='M170 85c0 46.944-38.056 85-85 85S0 131.944 0 85 38.056 0 85 0s85 38.056 85 85M47.095 85c0 20.934 16.97 37.905 37.905 37.905 20.934 0 37.905-16.971 37.905-37.905S105.934 47.095 85 47.095 47.095 64.065 47.095 85'
    />
  </svg>
);
export default SvgPieChartEmpty;
